import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b5040e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = ["innerHTML"]

import { onMounted, onUnmounted, ref, watch } from 'vue'
import { DateTime } from 'ts-luxon'

import { useStore } from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'CountDown',
  props: {
    blok: null
  },
  setup(__props: any) {

const props = __props as { blok: { finish: string } };


const text = ref<string | null>('')
const store = useStore()
const countdown = () => {
  if (!props.blok.finish) return null

  const date = DateTime.fromFormat(props.blok.finish, 'yyyy-MM-dd HH:mm').toJSDate()
  const now = new Date()

  const diff = date.getTime() - now.getTime()
  if (diff < 0) return null

  const days = Math.floor(diff / (1000 * 60 * 60 * 24))
  const hours = Math.floor(diff / (1000 * 60 * 60)) % 24
  const minutes = Math.floor(diff / (1000 * 60)) % 60
  const seconds = Math.floor(diff / 1000) % 60
  return `
            <span>${days} & ${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${
    seconds < 10 ? '0' : ''
  }${seconds}</span>`
}

let timer: any = null
onMounted(() => {
  text.value = countdown()
  timer = setInterval(() => {
    text.value = countdown()
  }, 1000)
})

watch(
  () => props.blok.finish,
  () => {
    text.value = countdown()
  }
)

onUnmounted(() => {
  clearInterval(timer)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (text.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "countdown",
          innerHTML: text.value
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}
}

})